import React, { useState, useEffect } from "react";
import Layout from "../../Layout";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { FiXSquare, FiTag } from "react-icons/fi";
import { Button, MenuSelect } from "../../components/Form";
import { FaSave } from "react-icons/fa";
import Select from 'react-select'
import { Input, Row, Col } from "reactstrap";
import { selectThemeColors } from "../../utils";
import { useNavigate } from "react-router";
import BackButton from "../../components/BackButton";
import { joinLab } from "../../api/labEmployee";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import TimePicker from 'react-time-picker';
import 'react-time-picker/dist/TimePicker.css';
// import ToothSelector from "../../components/ToothSelector";
import TeethSelect from "../../components/TeethSelection/TeethSelect"
import { DentalInput } from 'dental-input';
import AddProductModal from "../../components/Modals/AddProductModal";

function AddNewCase() {
    const navigate = useNavigate();

    const [invitationCode, setInvitationCode] = useState("");
    const [loading, setLoading] = useState(false);
    const [selectedDateTime1, setSelectedDateTime1] = useState(new Date());
    const [selectedDateTime2, setSelectedDateTime2] = useState(new Date());
    const [selectedDateTime3, setSelectedDateTime3] = useState(new Date());
    const [notes, setNotes] = useState('');
    const [dropdown1, setDropdown1] = useState('');
    const [dropdown2, setDropdown2] = useState('');

    const [inputValue, setInputValue] = useState('');

    const [selectedTooth, setSelectedTooth] = useState({});
    const [isOpen, setIsOpen] = React.useState(false);

    const [additionalButtons, setAdditionalButtons] = useState([]);
    const [selectedConditions, setSelectedConditions] = useState([]);

    const handleAddButtonClick = () => {
        // Here you can add your custom logic to determine what kind of button to add
        // For now, let's just add a default button
        setAdditionalButtons([...additionalButtons, <Button className="bg-[] text-white" label="New Button" onClick={() => setIsOpen(true)} />]);
    };

    useEffect(() => {
        // Example: Add a default set of buttons
        setAdditionalButtons([
            <Button key="1" className="bg-[] text-white" label="Crown" onClick={() => setIsOpen(true)} />,
            <Button key="2" className="bg-[] text-white" label="Bridge" onClick={() => setIsOpen(true)} />,
            <Button key="3" className="bg-[] text-white" label="INLAY" onClick={() => setIsOpen(true)} />,
            <Button key="4" className="bg-[] text-white" label="Denture" onClick={() => setIsOpen(true)} />,
            <Button key="5" className="bg-[] text-white" label="Skeleton" onClick={() => setIsOpen(true)} />,
            <Button key="6" className="bg-[] text-white" label="MISC" onClick={() => setIsOpen(true)} />,
        ]);
    }, []);

    const doctors = [
        {
            "label": "Option 1",
            "value": "option1"
        },
        {
            "label": "Option 2",
            "value": "option2"
        },
        {
            "label": "Option 3",
            "value": "option3"
        }
    ]

    const status = [
        {
            "value": "option1",
            "label": "In Progress"
        },
        {
            "value": "option2",
            "label": "On Hold"
        },
        {
            "value": "option3",
            "label": "Finished"
        },
        {
            "value": "option4",
            "label": "Pending Accept"
        },
        {
            "value": "option5",
            "label": "Ready for shipping to doctor"
        },
        {
            "value": "option6",
            "label": "Cancelled"
        }
    ]
    
    
    const handleSelectTooth = (toothNumber) => {
        setSelectedTooth((prevSelectedTooth) => {
            const updatedTooth = { [toothNumber]: prevSelectedTooth[toothNumber] || [] };
            return {
                ...prevSelectedTooth,
                ...updatedTooth
            };
        });
    };
    

    const handleSelectCondition = (toothNumber, condition) => {
        setSelectedTooth((prevSelectedTooth) => ({
            ...prevSelectedTooth,
            [toothNumber]: [...prevSelectedTooth[toothNumber], condition]
        }));
    };

    const handleRemoveCondition = (toothNumber, condition) => {
        setSelectedTooth((prevSelectedTooth) => ({
            ...prevSelectedTooth,
            [toothNumber]: prevSelectedTooth[toothNumber].filter((c) => c !== condition)
        }));
    };

    const onCloseModal = () => {
        setIsOpen(false);
    };

    // Function to receive selectedItemName and steps
    const handleAddProduct = (selectedItemName, steps) => {
        console.log("Selected Item Name:", selectedItemName);
        console.log("Steps:", steps);
        setIsOpen(false);
        // Perform actions with selectedItemName and steps here
    };

    const handleInputChange = (event) => {
        setInputValue(event.target.value);
    };

    // Your click handler function
    function handleOptionClick(item) {
        console.log('Clicked on', item.name);
        // Handle the click action as needed
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);
        const res = await joinLab({ invitationCode: invitationCode });
        if (res) {
            setLoading(false);
            setInvitationCode("");
            navigate("/");
        }
        setLoading(false);
        setInvitationCode("");
    }

    const handleBackClick = () => {
        // Handle the back button click event
        navigate(-1); // Go back one step in history
    };

    return (
        <Layout>

            {
                // add doctor modal
                isOpen && (
                    <AddProductModal
                        closeModal={handleAddProduct}
                        isOpen={isOpen}
                        doctor={true}
                        datas={null}
                    />
                )
            }
            <div>
                <BackButton onClick={handleBackClick} />
            </div>
            <div className="bg-gray-100 p-4 mt-5">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 sx:grid-cols-1" >
                    {/* Dropdown */}
                    <div>
                        <label htmlFor="type" className="block text-sm font-medium text-gray-600">Doctor</label>
                        <Select
                            name="sender_city"
                            className="mt-1"
                            onChange={(e) => this.onInputchange(e, "sender_city")}
                            options={doctors}
                            value={null}
                            isClearable={true}
                            classNamePrefix="select"
                            theme={selectThemeColors}
                        />
                    </div>

                    {/* Input Field 1 */}
                    <div>
                        <label htmlFor="input1" className="block text-sm font-medium text-gray-600">Patient</label>
                        <Input type="text" id="input1" name="input1" className="mt-1 p-2 w-full border rounded-md" />
                    </div>

                    {/* Input Field 2 */}
                    <div>
                        <label htmlFor="input2" className="block text-sm font-medium text-gray-600">Case number</label>
                        <Input type="text" id="input2" name="input2" className="mt-1 p-2 w-full border rounded-md" />
                    </div>
                </div>
            </div>

            <div className="bg-gray-100 p-4 md:p-4">
                <div className="mb-4">
                    <h2 className="text-md font-semibold text-gray-800">Schedule</h2>
                    <hr className="my-2 border-t-1 border-gray-300" />
                </div>
                <Row className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
                    {/* Date and Time Picker 1 */}
                    <Col className="mb-4 md:mb-0">
                        <label htmlFor="dateTime1" className="block text-sm font-medium text-gray-600">Date Received</label>
                        <DatePicker
                            selected={selectedDateTime1}
                            onChange={(date) => setSelectedDateTime1(date)}
                            showTimeSelect
                            dateFormat="MM/dd/yyyy h:mm aa"
                            className="mt-1 block w-full p-2 border rounded-md"
                        />
                    </Col>

                    {/* Date and Time Picker 2 */}
                    <Col className="mb-4 md:mb-0">
                        <label htmlFor="dateTime2" className="block text-sm font-medium text-gray-600">Ship Date</label>
                        <DatePicker
                            selected={selectedDateTime2}
                            onChange={(date) => setSelectedDateTime2(date)}
                            showTimeSelect
                            dateFormat="MM/dd/yyyy h:mm aa"
                            className="mt-1 block w-full p-2 border rounded-md"
                        />
                    </Col>

                    {/* Date and Time Picker 3 */}
                    <Col className="mb-4 md:mb-0">
                        <label htmlFor="dateTime3" className="block text-sm font-medium text-gray-600">Finish Date</label>
                        <DatePicker
                            selected={selectedDateTime3}
                            onChange={(date) => setSelectedDateTime3(date)}
                            showTimeSelect
                            dateFormat="MM/dd/yyyy h:mm aa"
                            className="mt-1 block w-full p-2 border rounded-md"
                        />
                    </Col>
                </Row>
            </div>

            <div className="bg-gray-100 p-4 grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Notes Input */}
                <div>
                    <label htmlFor="notes" className="block text-sm font-medium text-gray-600">Notes</label>
                    <textarea
                        id="notes"
                        name="notes"
                        rows="5"
                        value={notes}
                        onChange={(e) => setNotes(e.target.value)}
                        className="mt-1 block w-full p-2 border rounded-md resize-none"
                    />
                </div>

                {/* Dropdowns (displayed vertically) */}
                <div className="md:flex space-y-4 md:space-y-0 md:flex-col">
                    <div className="mb-0 md:mb-0">
                    <div>
                        <label htmlFor="type" className="block text-sm font-medium text-gray-600">Status</label>
                        <Select
                            name="sender_city"
                            className="mt-1"
                            onChange={(e) => setDropdown1(e)}
                            options={status}
                            value={dropdown1}
                            isClearable={true}
                            classNamePrefix="select"
                            theme={selectThemeColors}
                        />
                    </div>

                        <div className="max-w-4xl mx-auto my-8">
                            <div className="mb-4">
                                <label htmlFor="dropdown1" className="block text-sm font-medium text-gray-600 mb-1">ADD TAG</label>
                                <div className="flex gap-2">
                                    <FiTag size={30} fill="red" color="red" />
                                    <FiTag size={30} fill="orange" color="orange" />
                                    <FiTag size={30} fill="green" color="green" />
                                    <FiTag size={30} fill="blue" color="blue" />
                                    <FiTag size={30} fill="purple" color="purple" />
                                    <FiTag size={30} fill="gray" color="gray" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>

                    </div>
                </div>
            </div>
            {/* <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-2">
                <TeethSelect
                    selectedTooth={selectedTooth}
                    onSelectTooth={handleSelectTooth}
                />
                {selectedTooth ?
                    <div className="max-w-4xl mx-auto my-8">
                        <div className="mb-4">
                            <h2 className="text-lg font-semibold mb-3">ADD NEW PRODUCT</h2>
                            <div className="flex gap-2">
                                <Button className="bg-[] text-white" label="Crown" onClick={() => setIsOpen(true)} />
                                <Button className="bg-[] text-white" label="Bridge" onClick={() => setIsOpen(true)} />
                                <Button className="bg-[] text-white" label="INLAY" onClick={() => setIsOpen(true)} />
                                <Button className="bg-[] text-white" label="Denture" onClick={() => setIsOpen(true)} />
                                <Button className="bg-[] text-white" label="Skeleton" onClick={() => setIsOpen(true)} />
                                <Button className="bg-[] text-white" label="MISC" onClick={() => setIsOpen(true)} />
                            </div>
                            <Input placeholder="ADD MORE" color="#000" />
                            <Button className="bg-[] text-white" label="+ADD" />
                        </div>
                        <div>
                            <h2 className="text-lg font-semibold mb-3">DESCRIBE CONDITION</h2>
                            <div className="flex gap-2">
                                <Button className="bg-[#60a5fa] text-white" label="NO TOOTH" />
                                <Button className="bg-[#60a5fa] text-white" label="DEAD TOOTH" />
                                <Button className="bg-[#60a5fa] text-white" label="IMPLANT" />
                            </div>
                        </div>
                    </div>
                    : null}
            </div> */}

            <div className="bg-gray-100 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-2">
                <TeethSelect
                    selectedTooth={Object.keys(selectedTooth)} // Pass an array of tooth numbers
                    onSelectTooth={handleSelectTooth}
                />
                {Object.keys(selectedTooth).length > 0 ? (
                    <div className="max-w-4xl mx-auto my-2">
                        <div className="mb-4">
                            <h2 className="text-lg font-semibold mb-3">ADD NEW PRODUCT</h2>
                            <div className="flex gap-2" style={{ overflowX: 'auto' }}>
                                <div style={{ display: 'flex', gap: '1rem' }}>
                                    {additionalButtons.map((button, index) => (
                                        <React.Fragment key={index}>{button}</React.Fragment>
                                    ))}
                                </div>
                            </div>
                            {/* <Input placeholder="ADD MORE" color="#000" />
                            <Button className="bg-[] text-white" label="+ADD" onClick={handleAddButtonClick} /> */}
                        </div>
                        {/* Condition selection */}
                        <div className="mb-4">
                            <h2 className="text-lg font-semibold">DESCRIBE CONDITION</h2>
                            {/* Display conditions for each selected tooth */}
                            {Object.entries(selectedTooth).map(([toothNumber, conditions]) => (
                                <div className="mt-4" key={toothNumber}>
                                    <h3>Tooth {toothNumber}</h3>
                                    <div className="flex gap-2">
                                        <Button className="bg-[#60a5fa] text-white" label="NO TOOTH" onClick={() => handleSelectCondition(toothNumber, "No Tooth")} />
                                        <Button className="bg-[#60a5fa] text-white" label="DEAD TOOTH" onClick={() => handleSelectCondition(toothNumber, "Dead Tooth")} />
                                        <Button className="bg-[#60a5fa] text-white" label="IMPLANT" onClick={() => handleSelectCondition(toothNumber, "Implant")} />
                                    </div>
                                    {/* Display selected conditions for the tooth */}
                                    <ul>
                                        {conditions.map((condition, index) => (
                                            <li className="flex justify-between m-1 items-center shadow" key={index}>
                                            <span>{condition}</span>
                                            <button onClick={() => handleRemoveCondition(toothNumber, condition)}>
                                                <FiXSquare color="red" size={13} />
                                            </button>
                                        </li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                        </div>
                    </div>
                ) : null}
            </div>

            <div className="mb-4">
                <Button className="bg-[] text-white" label="Save" />
            </div>
        </Layout>
    );
}

export default AddNewCase;
